var _path, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.39024 14.8877C4.45831 15.7337 4.89932 16.5258 5.62393 17.1037C6.34853 17.6816 7.30254 18.002 8.29268 18H11.7073C12.6975 18.002 13.6515 17.6816 14.3761 17.1037C15.1007 16.5258 15.5417 15.7337 15.6098 14.8877L16.3659 5.25848H18V4.42297H13V3.46214C13 3.07436 12.8201 2.70246 12.4999 2.42825C12.1798 2.15405 11.7455 2 11.2927 2H8.70732C8.25451 2 7.82024 2.15405 7.50006 2.42825C7.17988 2.70246 7 3.07436 7 3.46214V4.42297H2V5.25848H3.63415L4.39024 14.8877ZM14.6341 14.8251C14.5846 15.4604 14.2545 16.0559 13.7109 16.4904C13.1672 16.9249 12.4509 17.1659 11.7073 17.1645H8.29268C7.54909 17.1659 6.83275 16.9249 6.28914 16.4904C5.74554 16.0559 5.41542 15.4604 5.36585 14.8251L4.63415 5.2376H15.3902L14.6341 14.8251ZM7.97561 3.46214C7.97561 3.29595 8.0527 3.13656 8.18992 3.01904C8.32714 2.90153 8.51326 2.83551 8.70732 2.83551H11.2927C11.4867 2.83551 11.6729 2.90153 11.8101 3.01904C11.9473 3.13656 12.0244 3.29595 12.0244 3.46214V4.42297H7.97561V3.46214Z",
    fill: "#30556B"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.51252,
    y1: 8.50115,
    x2: 8.50103,
    y2: 13.5011,
    stroke: "#30556B",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11.5,
    y1: 8.50001,
    x2: 11.4999,
    y2: 13.5,
    stroke: "#30556B",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.f32c751aee423c48dc0a5f0ff7ccd136.svg";
export { ForwardRef as ReactComponent };